import { Modal, TouchableOpacity, View } from 'react-native';
import React, { useEffect, useState } from 'react';
import {
  appColors,
  appFonts,
  fontSize,
} from 'zen-core-elements/src/shared/constants';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import CommonHeader from '../../../shared/commonComponents/commonHeader';
import StoreImageGallery from './imageGallery';
import { useIsFocused } from '@react-navigation/native';
import { useAppDispatch } from '../../../redux/hooks';
import { getPosAdminSettings } from '../../../redux/slices/imageGallerySlice';
import { ZenLoader } from 'zen-core-elements';
import { CustomModal } from '../../../shared/commonComponents/customModal';

const ImageGalleryScreen = () => {
  const TopTab = createMaterialTopTabNavigator();
  const [transparentLoader, setTransparentLoader] = useState(true);
  const dispatch = useAppDispatch();
  const [isVideoTabAvailable, setIsVideoTabAvailable] = useState(false);
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      getVideoSettings();
    }
  }, [isFocused]);

  const getVideoSettings = async () => {
    await dispatch(getPosAdminSettings())
      .unwrap()
      .then(response => {
        if (response?.success) {
          setIsVideoTabAvailable(response?.details?.isActive);
          setTransparentLoader(false);
        }
      });
  };

  return (
    <View style={{ flex: 1 }}>
      <CommonHeader headerName="Store Gallery" />

      {!transparentLoader ? (
        isVideoTabAvailable ? (
          <TopTab.Navigator
            initialRouteName="Image"
            screenOptions={{
              tabBarLabelStyle: {
                fontSize: fontSize.largerFontSize,
                fontFamily: appFonts.bold,
                textTransform: 'capitalize',
              },
              tabBarIndicatorStyle: { backgroundColor: appColors.primary },
              tabBarActiveTintColor: appColors.primary,
              tabBarInactiveTintColor: appColors.lightFontColor,
              tabBarAndroidRipple: { borderless: false },
            }}
            backBehavior="none">
            <TopTab.Screen
              name="Image"
              options={{ tabBarLabel: 'Image' }}
              children={() => <StoreImageGallery isImage={true} />}
            />
            <TopTab.Screen
              name="Video"
              options={{ tabBarLabel: 'Video' }}
              children={() => <StoreImageGallery isImage={false} />}
            />
          </TopTab.Navigator>
        ) : (
          <StoreImageGallery isImage={true} />
        )
      ) : null}
      <CustomModal visible={transparentLoader} transparent>
        <ZenLoader
          viewStyle={{ backgroundColor: 'transparent' }}
          color={appColors?.primary}
          lottieType="Local"
          lottie={require('../../../assets/infinityLoader.json')}
        />
      </CustomModal>
    </View>
  );
};

export default ImageGalleryScreen;
